<style scoped lang="scss">
  .summary-menu{
    background: rgba(0,0,0,.6);
    position: absolute;
    bottom:0;
    left:0;
    right:0;
    z-index: 3;
    ul{
      display: flex;
      padding:0 10%;
      li{
        width:140px;
        font-size: 16px;
        text-align: center;
      }
    }
  }
</style>
<style lang="scss">
  .wrap-summary{
    .el-menu--horizontal{
      margin-top: 0 !important;
      background: none;
      display: flex;
      justify-content: center;
      .el-menu-item{
        color:#fff;
        margin-right: 0 !important;
      }
    }
    .el-menu--horizontal>.el-menu-item.is-active{
      background: #fff !important;
      color:#333;
      border-bottom: 0;
    }
  }
</style>
<style scoped>
@media screen and (max-width: 640px){
  .container{
    width: 100% !important;
  }
  .container li{
    font-size: 12px!important;
  }
  .el-menu--horizontal>.el-menu-item{
    height: 40px!important;
    line-height: 40px!important;
  }
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .container{
    width: 100% !important;
  }
  .wrap-summary .el-menu--horizontal{
    width: 100% !important;
  }
  .wrap-summary .el-menu--horizontal>.el-menu-item {
    margin-right: auto!important;
    width: 72px!important;
    margin-left: auto!important;
  }
  .wrap-summary .el-menu--horizontal>.el-menu-item.is-active{
    padding-left: 10px;
  }
}
</style>
<template>
  <div class="summary-menu">
    <div class="container">
      <el-menu :router="true" :default-active="currentPath" class="el-menu-demo" mode="horizontal">
        <el-menu-item :index="item.ref" v-for="(item, index) in menuLists" :key="index">{{item.name}}</el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: 'qk-top-menu',
  props: {
    menuLists: {
      type: Array
    }
  },
  data () {
    return {
      currentPath: ''
    }
  },
  created() {
    this.getCurrentRoute()
  },
  methods: {
    getCurrentRoute () {
      this.currentPath = this.$route.path
    }
  },
  watch: {
    $route (to, from) {
      this.getCurrentRoute()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/topMenu.vue